const { select } = require('./../../../_global/js/utility/utils');
import ScrollMagic from 'ScrollMagic';
import { gsap } from 'gsap';

let duration = .8,
    ease = 'power2.inOut';



const initComposition = (container = document) => {
  const controller = new ScrollMagic.Controller();
  const tl = gsap.timeline();

  const composition = select('.composition', container);
  if (composition == null) return;
  const rectangle = select('.rectangle', container);
  const keyboard = select('.keyboard', container);
  const mouse = select('.mouse', container);
  const book = select('.book', container);
  const ipad = select('.ipad', container);
  const plant = select('.plant', container);



  tl.from(rectangle, {
    autoAlpha: 0,
    y: 100,
    x: -100,
    duration: duration,
    ease: ease
  });

  tl.from(keyboard, {
    autoAlpha: 0,
    y: 100,
    x: 100,
    duration: duration,
    ease: ease
  }, `-=${duration/1.5}`);

  tl.from(mouse, {
    autoAlpha: 0,
    y: 250,
    duration: duration,
    ease: ease
  }, `-=${duration/1.5}`);

  tl.from(book, {
    autoAlpha: 0,
    y: 200,
    x: -50,
    duration: duration,
    ease: ease
  }, `-=${duration/1.5}`);

  tl.from(ipad, {
    autoAlpha: 0,
    y: 50,
    x: -200,
    duration: duration,
    ease: ease
  }, `-=${duration/1.5}`);

  tl.from(plant, {
    autoAlpha: 0,
    y: 50,
    x: 200,
    duration: duration,
    ease: ease
  }, `-=${duration/1.5}`);



  const scene = new ScrollMagic.Scene({
    triggerElement: composition,
    triggerHook: 0.7,
    reverse: false
  }).setTween(tl).addTo(controller);
}



export default initComposition;
